export default __webpack_public_path__ + "static/media/directions-iHunt.0fbd51b1.png";